import { LocationStrategy, PathLocationStrategy, registerLocaleData } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import localeIt from '@angular/common/locales/it'
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AngularErrorHandler } from '@core/services/angularerrorhandler'
import { AngularLoggerService } from '@core/services/angularlogger.service'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat'
import { ButtonModule } from 'primeng/button'
import { InputTextModule } from 'primeng/inputtext'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { CoreModule } from './core/core.module'
import { TranslocoRootModule } from './transloco-root.module'
registerLocaleData(localeIt)

@NgModule({
	imports: [CoreModule, BrowserModule, BrowserAnimationsModule, ButtonModule, InputTextModule, AppRoutingModule, FontAwesomeModule, HttpClientModule, TranslocoRootModule],
	declarations: [AppComponent],
	providers: [
		{ provide: LocationStrategy, useClass: PathLocationStrategy },
		{ provide: LOCALE_ID, useValue: 'it-IT' },
		AngularLoggerService,
		{
			provide: ErrorHandler,
			useClass: AngularErrorHandler,
		},
		provideTranslocoMessageformat({
			locales: ['en-US', 'it-IT'],
		}),
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
